type DimensionsUnit = 'cm';

export interface Dimensions {
  length: number;
  width: number;
  height: number;
  unit: DimensionsUnit;
}

export function formatDimensions(dimensions?: Dimensions): string {
  if (!dimensions) return '';

  const { length, width, height, unit } = dimensions;

  if ((!length || length === 0) && (!width || width === 0) && (!height || height === 0)) {
    return '';
  }

  return `${length} × ${width} × ${height} ${unit}`;
}
